import { CameraResultType, CameraSource } from '@capacitor/camera';

export const rtcConfiguration: RTCConfiguration = {
  iceServers: [
    {
      urls: ['stun:turn.intoo.best:3478', 'turns:turn.intoo.best:5349'],
      username: 'seculib',
      credential: 'changeme',
    },
  ],
  iceCandidatePoolSize: 10,
};

export const TOKEN_STORAGE_KEY = 'NOBI_TOKEN';
export const USER_STORAGE_KEY = 'NOBI_USER';
export const SERVER_URL_KEY = 'SERVER_URL';
export const OVERRIDE_SERVER_URL_KEY = 'OVERRIDE_SERVER_URL';

export const NATIVE_MOBILE_PLATFORM = 'capacitor';

export const CRASH_REPORT_SERVER = 'https://crash-recover.intoo.best/';
export const INTOO_DEBUG_PASSWORD = 'in2';

export enum notificationType {
  CRENEAU_GARDIENNAGE_DEBUT_EN_RETARD = 'CRENEAU_GARDIENNAGE_DEBUT_EN_RETARD',
  CRENEAU_GARDIENNAGE_FIN_EN_AVANCE = 'CRENEAU_GARDIENNAGE_FIN_EN_AVANCE',
  ANOMALIE_GARDIENNAGE = 'ANOMALIE_GARDIENNAGE',
  DEFAUT_MATERIEL = 'DEFAUT_MATERIEL',
  ANOMALIE_RONDE = 'ANOMALIE_RONDE',
  ANOMALIE_RONDE_PONCTUELLE = 'ANOMALIE_RONDE_PONCTUELLE',
  RONDE_FIXE_DEBUT_RETARD = 'RONDE_FIXE_DEBUT_EN_RETARD',
  RONDE_FIXE_FIN_EN_AVANCE = 'RONDE_FIXE_FIN_EN_AVANCE',
  TOURNEE_DEBUT_RETARD = 'TOURNEE_DEBUT_EN_RETARD',
  TOURNEE_FIN_EN_AVANCE = 'TOURNEE_FIN_EN_AVANCE',

  RONDE_PASSAGE_RETARD = 'RONDE_PASSAGE_RETARD',
  RONDE_PASSAGE_EN_AVANCE = 'RONDE_PASSAGE_EN_AVANCE',
  RONDE_PASSAGE_NON_REALISE = 'RONDE_PASSAGE_NON_REALISE',

  ANOMALIE_INTER = 'ANOMALIE_INTER',
  ANOMALIE_ZONE = 'ANOMALIE_ZONE',

  ANOMALIE = 'ANOMALIE',
  PASSAGE = 'PASSAGE',
}

export enum StorageKeys {
  USER_EVENTS = 'USER_EVENTS',
  PROCHAIN_CRENEAU_GARDIENNAGE = 'PROCHAIN_CRENEAU_GARDIENNAGE',
  ZONES = 'ZONES',
  PROFILE_INFO = 'PROFILE_INFO',
  READ_ANOMALIES_GARDIENNAGE = 'READ_ANOMALIES_GARDIENNAGE',
  PARAM_TEL_DISPATCHER = 'PARAM_TEL_DISPATCHER',
  FCM_TOKEN = 'FCM_TOKEN',
  WANT_NOTIFICATIONS = 'WANT_NOTIFICATIONS',
  READ_MAIN_COURANTE_ADS = 'READ_MAIN_COURANTE_ADS',
  MODALITES_INTERVENTION = 'MODALITES_INTERVENTION',
  MOTIFS_REFUS = 'MOTIFS_REFUS',
}

export enum CreneauType {
  GARDIENNAGE = 'GARDIENNAGE',
  RONDE = 'RONDE',
  TOURNEE = 'TOURNEE',
  INTERVENTION = 'INTERVENTION',
  INTER_PONCTUELLE = 'INTER_PONCTUELLE',
}

export enum PointeauType {
  QRCODE = 'QRCODE',
}

export enum ChampPersonnaliseType {
  STRING = 'STRING',
  INT = 'INT',
  DOUBLE = 'DOUBLE',
  BOOLEAN = 'BOOLEAN',
  CHECKBOX_LIST = 'CHECKBOX_LIST',
  RADIO_LIST = 'RADIO_LIST',
  STRING_MULTILINE = 'STRING_MULTILINE',
  STRING_ARRAY = 'STRING_ARRAY',
  TOGGLE = 'TOGGLE',
  TEXT_INFO = 'TEXT_INFO',
}

export enum DeclarationType {
  DEFAUT_MATERIEL = 'DEFAUT_MATERIEL',
  ANOMALIE = 'ANOMALIE',
  // Deprecated
  ANOMALIE_GARDIENNAGE = 'ANOMALIE_GARDIENNAGE',
  // Deprecated
  ANOMALIE_RONDE = 'ANOMALIE_RONDE',
  // Deprecated
  ANOMALIE_INTER = 'ANOMALIE_INTER',
  // Deprecated
  ANOMALIE_INTER_PONCTUELLE = 'ANOMALIE_INTER_PONCTUELLE',

  DEBUT_EN_RETARD = 'DEBUT_EN_RETARD',
  FIN_EN_AVANCE = 'FIN_EN_AVANCE',

  // Deprecated
  CRENEAU_GARDIENNAGE_FIN_EN_AVANCE = 'CRENEAU_GARDIENNAGE_FIN_EN_AVANCE',
  // Deprecated
  CRENEAU_GARDIENNAGE_DEBUT_EN_RETARD = 'CRENEAU_GARDIENNAGE_DEBUT_EN_RETARD',
  // Deprecated
  TOURNEE_DEBUT_RETARD = 'TOURNEE_DEBUT_EN_RETARD',
  // Deprecated
  TOURNEE_FIN_EN_AVANCE = 'TOURNEE_FIN_EN_AVANCE',
  PASSAGE_EN_RETARD = 'PASSAGE_EN_RETARD',
  PASSAGE_EN_AVANCE = 'PASSAGE_EN_AVANCE',
  PASSAGE_NON_REALISE = 'PASSAGE_NON_REALISE',
  // Deprecated
  RONDE_PASSAGE_RETARD = 'RONDE_PASSAGE_RETARD',
  // Deprecated
  RONDE_PASSAGE_EN_AVANCE = 'RONDE_PASSAGE_EN_AVANCE',
  // Deprecated
  RONDE_PASSAGE_NON_REALISE = 'RONDE_PASSAGE_NON_REALISE',
  ARRIVEE_SUR_SITE = 'ARRIVEE_SUR_SITE',
  ACCES_AU_SITE = 'ACCES_AU_SITE',
  COMPTE_RENDU = 'COMPTE_RENDU',
  ANOMALIE_ZONE = 'ANOMALIE_ZONE',
  INFO_PASSAGE = 'PASSAGE',

  // Deprecated
  TYPE_INFO_PASSAGE = 'passage',
  INFO = 'INFO',
  // Deprecated
  TYPE_INFO_TEXTE = 'information',
}

export const SIGNATURE_PAD_OPTIONS = {
  minWidth: 1,
  maxWidth: 3,
  backgroundColor: 'rgb(255, 255, 255)',
  throttle: 8,
  minDistance: 2,
};

export const PHOTO_PLUGIN_OPTIONS = {
  quality: 40,
  resultType: CameraResultType.Uri,
  source: CameraSource.Camera,
  // encodingType: this.camera.EncodingType.JPEG,
  // mediaType: this.camera.MediaType.PICTURE,
  correctOrientation: true,
};

export const GALLERY_PLUGIN_OPTIONS = {
  quality: 40,
  resultType: CameraResultType.Uri,
  source: CameraSource.Photos,
  // encodingType: this.camera.EncodingType.JPEG,
  // mediaType: this.camera.MediaType.PICTURE,
  correctOrientation: true,
};
